import { useParams } from 'react-router-dom';
import { getLocale, SUPPORTED, DEFAULT_LANG } from './i18n';

// Returns the current language (from the :lang route param) and its translations.
export const useLang = () => {
  const { lang } = useParams();
  const current = SUPPORTED.includes(lang) ? lang : DEFAULT_LANG;
  return { lang: current, t: getLocale(current) };
};
